import { Button, Input } from '@convergence/components';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { useUpdateUserMutation } from '../api/mutations/useUpdateUser';
import CheckoutForm from '../components/checkout/CheckoutForm';
import { useErrorToast } from '../lib/useErrorToast';

const initialValues = {
  Email: '',
  'First Name': '',
  'Last Name': ''
} as const;

const schema = z.object({
  Email: z.email(),
  'First Name': z.string().nonempty(),
  'Last Name': z.string().nonempty()
});

type InitialValues = keyof typeof initialValues;

export function Checkout() {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors }
  } = useForm({
    defaultValues: initialValues,
    resolver: zodResolver(schema),
    mode: 'onBlur'
  });

  const { updateUser, error: updateUserError } = useUpdateUserMutation();

  useErrorToast(updateUserError);

  const [showCheckout, setShowCheckout] = useState(false);

  const values = getValues();
  console.log('values', values);

  return (
    <div className="h-full w-screen bg-white grid place-items-center overflow-auto">
      <div className="max-w-sm w-full bg-white flex flex-col gap-4 p-4 font-sans border-black border">
        <form
          className="flex flex-col gap-4"
          onSubmit={handleSubmit(async () => {
            const values = getValues();
            console.log('values', values);
            await updateUser({
              email: values.Email,
              firstname: values['First Name'],
              lastname: values['Last Name']
            });
            setShowCheckout(true);
          })}
        >
          <h1 className="text-2xl">Checkout</h1>
          {Object.keys(initialValues).map((key) => (
            <div key={`checkout-${key}`} className="flex flex-col gap-1">
              <Input
                className="border border-black bg-white p-1"
                key={key}
                {...register(key as InitialValues)}
                placeholder={key}
              />
              <div className="text-red-500 text-sm">
                {errors[key as InitialValues]?.message}
              </div>
            </div>
          ))}
          {!showCheckout && <Button type="submit">Next</Button>}
        </form>
        {showCheckout && <CheckoutForm />}
      </div>
    </div>
  );
}
